import { AnaColumn, costantValue } from "../forms-template.service";
import { aspect } from "./aspect";
import { gridSimple } from "./gridSettings/gridSettings";

export const testoAdr: AnaColumn[] = [
  {
    configuration:
    {
      titleGriglia: 'Testi Adr',
      titleForm: 'testo ADR',
      breadcrumbCaption: 'Gestione Testi ADR',

      service: 'testoAdr',
      api: 'testiAdr',
      filterList: '',
      filterEditor: '/$',

      formType: 'simple',
      masterKey: 'id',
      nCol: 1,
      idTabRif: [

        {
          key: 'eer',
          value: 'eer'
        },


      ],
    }

  },

  {
    itemType: "group", groupWidth: 800, groupDataField: 'datiTest', colCount: "3", caption: 'Testo ADR ',
    data: [


      {
        type: 'campo', dataField: "descrizione", caption: "Descrizione",
        orderGriglia: 1,
        width: '26.8vw',
        maxLength: "60",
        showInColumnChooser: true,
        allowHiding: false,
        colWidth: '200',
        colSpan: '3',
        validation: [{
          type: 'required', message: 'Il campo Descrizione è obbligatorio'
        }]
      },
      //-------------------------------------------------------------------
      {
        showInColumnChooser: true,
        allowHiding: false,
        type: 'campoSpecial', colVisible: true, dataField: "eer",
        colWidth: '90',
        colSpan: '1',
        orderGriglia: 2,
        width: '3.688vw',
        maxLength: '6',
        caption: "EER",
        disableOnUpdate: false,
        readonly: true,
        dynamic: {
          valueExpr: 'id',
          queryString: '',
          displayExpr: '',
          dataSource: 'cer',
          service: 'cer',
          autocomplete: true,
          filterStatic: "?$filter=(not endswith(id,'00'))",
          caption: "Lista EER",
          componentType: 'dynamicGrid',
          related: ['pericoloso|isCerPericoloso', 'descrizione|descrizioneAssegnata'],

          buttonOption: {
            text: 'Cer',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Sfoglia elenco dei rifiuti eer (F3)',
            name: 'eer',
            location: 'after',
          },
          settingGrid: gridSimple,

        },
        validation: [
          { type: 'required', message: 'Il campo EER obbligatorio' }
        ]
      },
      {
        type: 'campo', dataField: "isCerPericoloso", dataType: "", caption: "Pericoloso",
        orderGriglia: 3,
        colVisible: false,
        labelVisible: true,
        colSpan: '1',
        editorType: 'dxCheckBox',
        class: 'cer-pericoloso',
        defaultValue: false,
        disabled: true,
        disableOnUpdate: true,
        showInColumnChooser: false,
      },
      { type: 'empty', dataField: '', editorType: '', dataType: '' },
      /*  {
         type: 'campoSpecial', dataField: "descrizioneCer", dataType: "", caption: "EER.",
         colVisible: false,
         labelVisible: false,
         disableOnUpdate: true,
         showInColumnChooser:false,
         orderGriglia:4,     
         readonly:true,

         colSpan:'1',
         width:'19.4vw',
         class: '',
         dynamic: {
           queryString: '',
           displayExpr: 'descrizione',
           filterStatic: "?$filter=(not endswith(id,'00'))",
           dataSource: 'cer',
           service: 'cer',
           autocomplete: false,
           checkValue: {
             checkValueMessage: '',
             forceInsert: false
           },
           valueExpr: '',
           caption: "Lista EER",
           componentType: 'dynamicGrid',
           related: ['id|eer', 'pericoloso|isCerPericoloso'],
          
           buttonOption: {
             text: 'EER',
             icon: 'glyphicon mdi mdi-playlist-plus',
             hint: 'Sfoglia lista EER',
             name: 'Cer',
             location: 'after',
           },
           settingGrid: gridSimple
 
         },
 
       },
  */
      //-------------------------------------------------------------------


      {
        orderGriglia: 34,
        type: 'campoSpecial', dataField: "idClasseAdr", caption: "Classe",
        width: '26.8vw',
        colVisible: false,
        colSpan: '3',
        showInColumnChooser: true,
        disableOnUpdate: true,
        nCol: 10,
        dynamic: {
          valueExpr: 'id',
          queryString: '',
          displayExpr: 'descrizione',
          dataSource: 'adr',
          service: 'generic',
          autocomplete: false,
          caption: "Lista Classi ADR",
          componentType: 'dynamicGrid',
          buttonOption: {
            text: 'Classi',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Sfoglia elenco Classi ADR (F3)',
            name: 'classi',
            location: 'after',
          },
          settingGrid: gridSimple

        },

      },

      {
        orderGriglia: 36,
        type: 'campoSpecial', dataField: "idOnu", caption: "Onu",
        nCol: 10,
        width: '26.8vw',
        colSpan: '3',
        disableOnUpdate: true,
        colVisible: false,
        showInColumnChooser: true,
        dynamic: {
          valueExpr: 'id',
          queryString: '',
          displayExpr: 'descrizione',
          dataSource: 'Onu',
          service: 'generic',
          autocomplete: false,
          caption: "Lista Onu",
          componentType: 'dynamicGrid',
          buttonOption: {
            text: 'Cer',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Sfoglia elenco dei rifiuti eer (F3)',
            name: 'eer',
            location: 'after',
          },
          settingGrid: gridSimple

        },

      },


      {
        type: 'campo',
        colVisible: true,
        nCol: 10,
        colSpan: 3,
        showInColumnChooser: true,
        dataField: "testo",
        maxLength: '1000',
        editorType: 'dxTextArea',
        caption: "Testo",
        colWidth: '180',
      },


    ]
  },
]